import React, { useState } from "react";
import { Button, Modal, notification, Select } from "antd";
import { deleteCxGptProvider } from "util/copilotChatApi";
import CxGptProviderKeyModal from "./CxGptProviderKeyModal";
import FacebookModal from "./facebookModel";
import InstagramModal from "./instagramModel";
import TwitterModal from "./twitterModel";
import ZendeskTicketsModal from "./zendeskTicketsModel";
import ZendeskChatModal from "./zendeskChatModel";
import WhatsappModal from "./whatsappModel";
import SlackView from "./slackView";
import TrelloView from "./trelloView";
import McpView from "./mcpView";
import CrmView from "./crmView";
import { fetchZendeskConnectLink } from "util/zendeskAppApi";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

const Wrapper = ({ title, subtitle, children }) => (
  <div className={styles.wrapper}>
    <h2 className={styles.wrapperTitle}>{title}</h2>
    <p className={styles.wrapperSubtitle}>{subtitle}</p>
    {children}
  </div>
);

const CustomDropDown = ({ onChange, selectedOption, options, placeholder }) => (
  <Select
    className={styles.dropdown}
    placeholder={placeholder}
    onChange={onChange}
    value={selectedOption}
    showSearch
    optionFilterProp="title"
  >
    <Select.Option style={{ display: "none" }}>{placeholder}</Select.Option>
    {options?.map(({ value, label }) => (
      <Select.Option key={value} value={value} title={label}>
        {label}
      </Select.Option>
    ))}
  </Select>
);

const Card = ({ title, subtitle, integrated, onClick, asset, actionLabel }) => (
  <div className={styles.card}>
    <div className={styles.cardContent}>
      <div className={styles.cardImage}>{asset}</div>
      <div className={styles.cardText}>
        <p className={styles.cardTitle}>{title}</p>
        <p className={styles.cardSubtitle}>{subtitle}</p>
      </div>
    </div>
    <Button
      className={`${styles.btn} ${integrated ? styles.outlined : ""}`}
      onClick={onClick}
    >
      {integrated
        ? i18n.t("button.22")
        : actionLabel || i18n.t("button.21")}
    </Button>
  </div>
);

const Representation = ({
  user,
  integrations,
  selectedFilter,
  setSelectedFilter,
  showFacebookModal,
  setShowFacebookModal,
  showInstagramModal,
  setShowInstagramModal,
  showTwitterModal,
  setShowTwitterModal,
  showZendeskTicketsModal,
  setShowZendeskTicketsModal,
  showZendeskChatModal,
  setShowZendeskChatModal,
  showWhatsappModal,
  setShowWhatsappModal,
  subscriptionStatus,
  setDeleteModal,
  deleteModalText,
  deleteKeys,
  activateClickup,
  activateJira,
  activateMetaPosts,
  activateMetaAds,
  activateTiktok,
  activateLinkedIn,
  showSlackView,
  setShowSlackView,
  showTrelloView,
  setShowTrelloView,
  showMcpView,
  setShowMcpView,
  showCrmView,
  setShowCrmView,
  getSubscribtionStatus,
  theme,
  cxGptProviders,
  cxGptSettingsLoading,
  refreshCxGptSettings,
  integrationFilterOrder,
}) => {
  const { t } = useTranslation();
  const [llmModalProvider, setLlmModalProvider] = useState(null);

  const openAiActive = Boolean(
    Array.isArray(cxGptProviders) &&
      cxGptProviders.find((x) => x.provider === "openai" && x.connected)
  );
  const deepseekActive = Boolean(
    Array.isArray(cxGptProviders) &&
      cxGptProviders.find((x) => x.provider === "deepseek" && x.connected)
  );

  const openZendeskConnect = async () => {
    try {
      const res = await fetchZendeskConnectLink();
      if (res?.url) {
        window.open(res.url, "_blank", "noopener");
      } else {
        notification.error({ message: res?.error || t("notifications.1") });
      }
    } catch (e) {
      notification.error({ message: t("notifications.1") });
    }
  };

  const handleLlmRevoke = (prov) => {
    Modal.confirm({
      title:
        prov === "openai" ? t("settings.232") : t("settings.233"),
      content: t("settings.231"),
      okText: i18n.t("button.22"),
      cancelText: t("settings.72"),
      onOk: async () => {
        const res = await deleteCxGptProvider(prov);
        if (res && res.success) {
          notification.success({ message: t("cx_gpt.settings_saved") });
          if (typeof refreshCxGptSettings === "function") {
            refreshCxGptSettings();
          }
        } else if (res && res.error) {
          notification.error({ message: String(res.error) });
        } else if (res && res.cancel) {
          notification.error({ message: t("cx_gpt.network_error") });
        }
      },
    });
  };

  const ModalStyle = {
    padding: "45px",
    borderRadius: "15px",
    background: theme === "dark" ? "#1C193B" : "#ffffff",
    overflow: "hidden",
  };
  return (
    <>
      {!showSlackView && !showTrelloView && !showMcpView && !showCrmView ? (
        <Wrapper title={t("settings.54")} subtitle={t("settings.55")}>
          <div className={styles.integrationContainer}>
            <CustomDropDown
              onChange={(value) => setSelectedFilter(value)}
              selectedOption={selectedFilter}
              options={integrationFilterOrder.map((f) => ({
                value: f.id,
                label: t(f.labelKey),
              }))}
              placeholder={t("others.20")}
            />
            <div className={styles.container}>
              <p className={styles.llmHint}>{t("settings.227")}</p>
              {integrations[selectedFilter].includes("MCP") && (
                <Card
                  title={t("settings.279")}
                  subtitle={t("settings.280")}
                  asset={
                    <img
                      width="40"
                      height="40"
                      src="/assets/settings/pivony-icon.svg"
                      alt=""
                    />
                  }
                  integrated={false}
                  actionLabel={t("settings.335")}
                  onClick={() => setShowMcpView(true)}
                />
              )}
              {integrations[selectedFilter].includes("CRM") && (
                <Card
                  title={t("crmConnection.card_title")}
                  subtitle={t("crmConnection.card_subtitle")}
                  asset={
                    <img
                      width="40"
                      height="40"
                      src="/assets/settings/pivony-icon.svg"
                      alt=""
                    />
                  }
                  integrated={false}
                  actionLabel={t("settings.335")}
                  onClick={() => setShowCrmView(true)}
                />
              )}
              {integrations[selectedFilter].includes("Pivony for Zendesk") && (
                <Card
                  title={t("settings.345")}
                  subtitle={t("settings.346")}
                  asset={
                    <img
                      width="40"
                      height="40"
                      src="/assets/settings/zendesk.svg"
                      alt=""
                    />
                  }
                  integrated={false}
                  actionLabel={t("settings.347")}
                  onClick={openZendeskConnect}
                />
              )}
              <Card
                title={t("settings.223")}
                subtitle={t("settings.224")}
                asset={
                  <img
                    width="40"
                    height="40"
                    src="/assets/settings/openai.svg"
                    alt=""
                  />
                }
                integrated={openAiActive}
                onClick={() => {
                  if (cxGptSettingsLoading) return;
                  if (openAiActive) handleLlmRevoke("openai");
                  else setLlmModalProvider("openai");
                }}
              />
              <Card
                title={t("settings.225")}
                subtitle={t("settings.226")}
                asset={
                  <img
                    width="40"
                    height="40"
                    src="/assets/settings/deepseek.svg"
                    alt=""
                  />
                }
                integrated={deepseekActive}
                onClick={() => {
                  if (cxGptSettingsLoading) return;
                  if (deepseekActive) handleLlmRevoke("deepseek");
                  else setLlmModalProvider("deepseek");
                }}
              />
              {integrations[selectedFilter].includes("Slack") &&
                subscriptionStatus?.slack_integration_status !== "hidden" && (
                  <Card
                    title="Slack"
                    subtitle={t("settings.66")}
                    asset={
                      <img
                        width="40"
                        height="40"
                        src="/assets/settings/slack-color.png"
                        alt=""
                      />
                    }
                    integrated={
                      subscriptionStatus?.slack_integration_status === "active"
                    }
                    onClick={() =>
                      subscriptionStatus?.slack_integration_status === "active"
                        ? setDeleteModal("Slack")
                        : [78, 79, 100].includes(subscriptionStatus?.PackageId)
                        ? setShowSlackView(true)
                        : notification.error({ message: t("settings.67") })
                    }
                  />
                )}
              {integrations[selectedFilter].includes("meta Posts") &&
                subscriptionStatus?.instagram_search_token_status !==
                  "hidden" && (
                  <Card
                    title={t("settings.58")}
                    subtitle={t("settings.59")}
                    asset={
                      <img
                        width="40"
                        height="40"
                        src="/assets/settings/meta.png"
                        alt=""
                      />
                    }
                    integrated={
                      subscriptionStatus?.meta_posts_access === "active"
                    }
                    onClick={() =>
                      subscriptionStatus?.meta_posts_access === "active"
                        ? setDeleteModal("Facebook and Instagram Posts")
                        : [78, 79, 77, 76, 100].includes(
                            subscriptionStatus?.PackageId
                          )
                        ? activateMetaPosts()
                        : notification.error({ message: t("settings.67") })
                    }
                  />
                )}
              {integrations[selectedFilter].includes("LinkedIn") && (
                <Card
                  title="LinkedIn"
                  subtitle={t("settings.222")}
                  asset={
                    <img
                      width="40"
                      height="40"
                      src={"/assets/linkedin.svg"}
                      alt=""
                    />
                  }
                  integrated={subscriptionStatus?.linkedin_status === "active"}
                  onClick={() =>
                    subscriptionStatus?.linkedin_status === "active"
                      ? setDeleteModal("LinkedIn")
                      : [78, 79, 77, 76, 100].includes(
                          subscriptionStatus?.PackageId
                        )
                      ? activateLinkedIn()
                      : notification.error({ message: t("settings.67") })
                  }
                />
              )}
              {/* 
{integrations[selectedFilter].includes("meta Ads") &&
                  subscriptionStatus?.facebook_page_token_status !== "hidden" &&
                  <Card
                    title={t("settings.56")}
                    subtitle={t("settings.57")}
                    asset={<img width="40" height="40" src="/assets/settings/meta.png" alt="" />}
                    integrated={subscriptionStatus?.meta_ads_access === "active"}
                    onClick={() => subscriptionStatus?.meta_ads_access === "active" ?
                    setDeleteModal("Facebook and Instagram ads") : ([78, 79, 77, 76, 100].includes(subscriptionStatus?.PackageId) ?
                      activateMetaAds() : notification.error({ message: t("settings.67") }))}
                  />} */}
              {/* {integrations[selectedFilter].includes("Twitter") &&
                  subscriptionStatus?.twitter_status !== "hidden" &&
                  <Card
                    title={t("settings.60")}
                    subtitle={t("settings.61")}
                    asset={<TwitterOutlined style={{ fontSize: '40px' }} />}
                    integrated={subscriptionStatus?.twitter_status === "active"}
                    onClick={() => subscriptionStatus?.twitter_status === "active" ?
                      setDeleteModal("Twitter") : setShowTwitterModal(true)}
                  />} */}
              {/* {integrations[selectedFilter].includes("TikTok") &&
                subscriptionStatus?.tiktok_status !== "hidden" &&
                <Card
                  title="TikTok"
                  subtitle="Analyze Account video comments in few taps"
                  asset={<img width="40" height="40" src={"/assets/settings/tiktok.png"} alt="" />}
                  integrated={subscriptionStatus?.tiktok_status === "active"}
                  onClick={() => subscriptionStatus?.tiktok_status === "active" ?
                    setDeleteModal("tiktok") : ([78, 79, 77, 76, 100].includes(subscriptionStatus?.PackageId) ?
                      activateTiktok() : notification.error({ message: t("settings.67") }))}
                />} */}
              {integrations[selectedFilter].includes("Zendesk Tickets") &&
                subscriptionStatus?.zendesk_ticket_token_status !==
                  "hidden" && (
                  <Card
                    title={t("settings.62")}
                    subtitle={t("settings.63")}
                    asset={
                      <img
                        width="40"
                        height="40"
                        src="/assets/settings/zendesk.svg"
                        alt=""
                      />
                    }
                    integrated={
                      subscriptionStatus?.zendesk_ticket_token_status ===
                      "active"
                    }
                    onClick={() =>
                      subscriptionStatus?.zendesk_ticket_token_status ===
                      "active"
                        ? setDeleteModal("Zendesk Tickets")
                        : setShowZendeskTicketsModal(true)
                    }
                  />
                )}
              {integrations[selectedFilter].includes("Zendesk Live Chat") &&
                subscriptionStatus?.zendesk_livechat_token_status !==
                  "hidden" && (
                  <Card
                    title={t("settings.64")}
                    subtitle={t("settings.65")}
                    asset={
                      <img
                        width="40"
                        height="40"
                        src="/assets/settings/zendesk.svg"
                        alt=""
                      />
                    }
                    integrated={
                      subscriptionStatus?.zendesk_livechat_token_status ===
                      "active"
                    }
                    onClick={() =>
                      subscriptionStatus?.zendesk_livechat_token_status ===
                      "active"
                        ? setDeleteModal("Zendesk Live Chat")
                        : setShowZendeskChatModal(true)
                    }
                  />
                )}
              {integrations[selectedFilter].includes("WhatsApp Business") &&
                subscriptionStatus?.whatsapp_status !== "hidden" && (
                  <Card
                    title="WhatsApp Business"
                    subtitle={t("settings.338")}
                    asset={
                      <img
                        width="40"
                        height="40"
                        src="/assets/settings/whatsapp.svg"
                        alt=""
                      />
                    }
                    integrated={
                      subscriptionStatus?.whatsapp_status === "active"
                    }
                    onClick={() =>
                      subscriptionStatus?.whatsapp_status === "active"
                        ? setDeleteModal("WhatsApp Business")
                        : setShowWhatsappModal(true)
                    }
                  />
                )}
              {user.plan !== 19 &&
                user.plan !== 65 &&
                user.plan !== 66 &&
                user.plan !== 67 && <></>}
              {integrations[selectedFilter].includes("Trello") &&
                subscriptionStatus?.trello_status !== "hidden" && (
                  <Card
                    title="Trello"
                    subtitle={t("settings.68")}
                    asset={
                      <img
                        width="40"
                        height="40"
                        src="/assets/settings/trello-color.png"
                        alt=""
                      />
                    }
                    integrated={subscriptionStatus?.trello_status === "active"}
                    onClick={() =>
                      subscriptionStatus?.trello_status === "active"
                        ? setDeleteModal("Trello")
                        : [78, 79, 77, 76, 100].includes(
                            subscriptionStatus?.PackageId
                          )
                        ? setShowTrelloView(true)
                        : notification.error({ message: t("settings.67") })
                    }
                  />
                )}
              {integrations[selectedFilter].includes("ClickUp") &&
                subscriptionStatus?.clickup_status !== "hidden" && (
                  <Card
                    title="ClickUp"
                    subtitle={t("settings.68")}
                    asset={
                      <img
                        width="40"
                        height="40"
                        src={"/assets/settings/clickup.png"}
                        alt=""
                      />
                    }
                    integrated={subscriptionStatus?.clickup_status === "active"}
                    onClick={() =>
                      subscriptionStatus?.clickup_status === "active"
                        ? setDeleteModal("ClickUp")
                        : [78, 79, 77, 76, 100].includes(
                            subscriptionStatus?.PackageId
                          )
                        ? activateClickup()
                        : notification.error({ message: t("settings.67") })
                    }
                  />
                )}
              {integrations[selectedFilter].includes("Jira") &&
                subscriptionStatus?.jira_status !== "hidden" && (
                  <Card
                    title="Jira"
                    subtitle={t("settings.68")}
                    asset={
                      <img
                        width="40"
                        height="40"
                        src={"/assets/settings/jira.svg"}
                        alt=""
                      />
                    }
                    integrated={subscriptionStatus?.jira_status === "active"}
                    onClick={() =>
                      subscriptionStatus?.jira_status === "active"
                        ? setDeleteModal("jira")
                        : [78, 79, 77, 76, 100].includes(
                            subscriptionStatus?.PackageId
                          )
                        ? activateJira()
                        : notification.error({ message: t("settings.67") })
                    }
                  />
                )}
            </div>
            <FacebookModal
              showModal={showFacebookModal}
              setShowModal={setShowFacebookModal}
              user={user}
              getSubscribtionStatus={getSubscribtionStatus}
            />
            <InstagramModal
              showModal={showInstagramModal}
              setShowModal={setShowInstagramModal}
              user={user}
              getSubscribtionStatus={getSubscribtionStatus}
            />
            <TwitterModal
              showModal={showTwitterModal}
              setShowModal={setShowTwitterModal}
              user={user}
              getSubscribtionStatus={getSubscribtionStatus}
            />
            <ZendeskTicketsModal
              showModal={showZendeskTicketsModal}
              setShowModal={setShowZendeskTicketsModal}
              user={user}
              getSubscribtionStatus={getSubscribtionStatus}
            />
            <ZendeskChatModal
              showModal={showZendeskChatModal}
              setShowModal={setShowZendeskChatModal}
              user={user}
              getSubscribtionStatus={getSubscribtionStatus}
            />
            <WhatsappModal
              showModal={showWhatsappModal}
              setShowModal={setShowWhatsappModal}
              user={user}
              getSubscribtionStatus={getSubscribtionStatus}
            />
            <CxGptProviderKeyModal
              open={llmModalProvider != null}
              provider={llmModalProvider}
              theme={theme}
              onClose={() => setLlmModalProvider(null)}
              onSaved={refreshCxGptSettings}
            />
            <Modal
              open={deleteModalText}
              bodyStyle={ModalStyle}
              footer={null}
              onCancel={() => setDeleteModal(null)}
              style={{ overflow: "hidden", borderRadius: "14px", padding: "0px" }}
            >
              <p className={styles.modalTitle}>
                {t("settings.69", { deleteModalText })}
              </p>
              <div className={styles.row}>
                <Button
                  className={`${styles.btn} ${styles.modalOutlined} ${styles.modalBtn}`}
                  onClick={() => setDeleteModal(null)}
                >
                  {t("settings.72")}
                </Button>
                <Button
                  className={`${styles.btn} ${styles.modalBtn}`}
                  onClick={() => deleteKeys(deleteModalText)}
                >
                  {t("button.22")}
                </Button>
              </div>
            </Modal>
          </div>
        </Wrapper>
      ) : showMcpView ? (
        <McpView onBack={() => setShowMcpView(false)} />
      ) : showCrmView ? (
        <CrmView onBack={() => setShowCrmView(false)} />
      ) : (
        <>
          {showSlackView ? (
            <SlackView user={user} />
          ) : (
            <TrelloView user={user} />
          )}
        </>
      )}
    </>
  );
};

export default Representation;
